import React, { useState } from 'react';

import { ColorPicker } from './components/ColorPicker';
import { ColorPickersContainer, Divider } from './styles';

import propTypes from 'prop-types';

export function ColorPickers({
  backgroundColor,
  setBackgroundColor,
  headerFooterColor,
  setHeaderFooterColor,
  primaryColor,
  setPrimaryColor,
  secondaryColor,
  setSecondaryColor,
  fontColor,
  setFontColor,
  fontColorSecondary,
  setFontColorSecondary,
  footerIconsColor,
  setFooterIconsColor,
}) {
  return (
    <ColorPickersContainer>
      <ColorPicker
        color={backgroundColor}
        setColor={setBackgroundColor}
        title="Cor de fundo"
      />
      <Divider />
      <ColorPicker
        color={headerFooterColor}
        setColor={setHeaderFooterColor}
        title="Cor do cabeçalho e rodapé"
      />
      <Divider />
      <ColorPicker
        color={primaryColor}
        setColor={setPrimaryColor}
        title="Cor primária"
      />
      <Divider />
      <ColorPicker
        color={secondaryColor}
        setColor={setSecondaryColor}
        title="Cor secundária"
      />
      <Divider />
      <ColorPicker
        color={fontColor}
        setColor={setFontColor}
        title="Cor da fonte"
      />
      <Divider />
      <ColorPicker
        color={fontColorSecondary}
        setColor={setFontColorSecondary}
        title="Cor da fonte secundária"
      />
      <Divider />
      <ColorPicker
        color={footerIconsColor}
        setColor={setFooterIconsColor}
        title="Cor dos ícones do rodapé"
      />
      <Divider />
    </ColorPickersContainer>
  );
}

ColorPicker.propTypes = {
  primaryColor: propTypes.string.isRequired,
  setPrimaryColor: propTypes.func.isRequired,
  secondaryColor: propTypes.string.isRequired,
  setSecondaryColor: propTypes.func.isRequired,
  fontColor: propTypes.string.isRequired,
  setFontColor: propTypes.func.isRequired,
};
